import React, { useState } from 'react';
import Header from './Header';

function Page2() {
  const page1Data = JSON.parse(sessionStorage.getItem('page1Data') || '{}');
  const { fiscalYear, town, formType } = page1Data;
  const isForm2 = formType === 'form_2';

  const [items, setItems] = useState([]);
  const [schedule, setSchedule] = useState('');
  const [ownOrOther, setOwnOrOther] = useState('Owned');
  const [description, setDescription] = useState('');
  const [quantity, setQuantity] = useState('');
  const [manufacturer, setManufacturer] = useState('');
  const [model, setModel] = useState('');
  const [yearOfManufacture, setYearOfManufacture] = useState('');
  const [yearOfPurchase, setYearOfPurchase] = useState('');
  const [purchasePrice, setPurchasePrice] = useState('');
  const [estimatedMarketValue, setEstimatedMarketValue] = useState('');

  const form2Schedules = [
    { value: 'A', label: 'A — Poles, conduits, wires and pipes' },
    { value: 'B', label: 'B — Machinery' },
    { value: 'C', label: 'C — Tools and equipment' },
    { value: 'D', label: 'D — Business furniture and fixtures' },
    { value: 'E', label: 'E — Merchandise / inventory' },
    { value: 'F', label: 'F — Unregistered motor vehicles and trailers' },
    { value: 'G', label: 'G — Animals' },
    { value: 'H', label: 'H — Forest products' },
    { value: 'I', label: 'I — Other taxable property and CWIP' },
    { value: 'J', label: 'J — Real property owned in town' },
  ];

  const form2hfSchedules = [
    { value: 'A', label: 'A — Appliances and small electronics' },
    { value: 'B', label: 'B — Tools and equipment' },
    { value: 'C', label: 'C — Furniture and accessories' },
    { value: 'D', label: 'D — Personal effects' },
    { value: 'E', label: 'E — Unregistered motor vehicles and trailers' },
    { value: 'F', label: 'F — Other taxable personal property' },
  ];

  const schedules = isForm2 ? form2Schedules : form2hfSchedules;

  const resetForm = () => {
    setSchedule('');
    setOwnOrOther('Owned');
    setDescription('');
    setQuantity('');
    setManufacturer('');
    setModel('');
    setYearOfManufacture('');
    setYearOfPurchase('');
    setPurchasePrice('');
    setEstimatedMarketValue('');
  };

  const handleAddItem = (e) => {
    e.preventDefault();
    const newItem = {
      schedule, ownOrOther, description, quantity,
      manufacturer, model, yearOfManufacture, yearOfPurchase,
      purchasePrice, estimatedMarketValue,
    };
    setItems([...items, newItem]);
    resetForm();
  };

  const handleRemoveItem = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };

  const handleContinue = () => {
    sessionStorage.setItem('page2Data', JSON.stringify(items));
    window.location.href = '/page3';
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <Header step={2} />
        <p style={styles.meta}>
          {isForm2 ? 'Form 2 — Business' : 'Form 2HF — Second Home'} &nbsp;|&nbsp; {town} &nbsp;|&nbsp; FY{fiscalYear}
        </p>
        <h2 style={styles.subtitle}>Page 2 — Reported Items</h2>
        <p style={styles.required}>* Required field</p>

        <form onSubmit={handleAddItem}>
          <div style={styles.field}>
            <label style={styles.label}>Schedule *</label>
            <select style={styles.input} value={schedule}
              onChange={(e) => setSchedule(e.target.value)} required>
              <option value="">Select a schedule...</option>
              {schedules.map((s) => (
                <option key={s.value} value={s.value}>{s.label}</option>
              ))}
            </select>
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Owned / Leased / Consigned *</label>
            <select style={styles.input} value={ownOrOther}
              onChange={(e) => setOwnOrOther(e.target.value)} required>
              <option value="Owned">Owned</option>
              <option value="Leased">Leased</option>
              <option value="Consigned">Consigned</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Description *</label>
            <input style={styles.input} type="text" value={description}
              onChange={(e) => setDescription(e.target.value)} required />
          </div>

          <div style={styles.row}>
            <div style={styles.halfField}>
              <label style={styles.label}>Quantity</label>
              <input style={styles.input} type="number" value={quantity}
                onChange={(e) => setQuantity(e.target.value)} />
            </div>
            <div style={styles.halfField}>
              <label style={styles.label}>Manufacturer</label>
              <input style={styles.input} type="text" value={manufacturer}
                onChange={(e) => setManufacturer(e.target.value)} />
            </div>
          </div>

          <div style={styles.row}>
            <div style={styles.halfField}>
              <label style={styles.label}>Model</label>
              <input style={styles.input} type="text" value={model}
                onChange={(e) => setModel(e.target.value)} />
            </div>
            <div style={styles.halfField}>
              <label style={styles.label}>Year of Manufacture</label>
              <input style={styles.input} type="number" value={yearOfManufacture}
                onChange={(e) => setYearOfManufacture(e.target.value)} />
            </div>
          </div>

          <div style={styles.row}>
            <div style={styles.halfField}>
              <label style={styles.label}>Year of Purchase</label>
              <input style={styles.input} type="number" value={yearOfPurchase}
                onChange={(e) => setYearOfPurchase(e.target.value)} />
            </div>
            <div style={styles.halfField}>
              <label style={styles.label}>Purchase Price</label>
              <input style={styles.input} type="number" value={purchasePrice}
                onChange={(e) => setPurchasePrice(e.target.value)} />
            </div>
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Estimated Market Value</label>
            <input style={styles.input} type="number" value={estimatedMarketValue}
              onChange={(e) => setEstimatedMarketValue(e.target.value)} />
          </div>

          <button style={styles.addButton} type="submit">+ Add Item</button>
        </form>

        {items.length > 0 && (
          <div style={styles.itemList}>
            <h3 style={styles.itemListTitle}>Items Added ({items.length})</h3>
            {items.map((item, index) => (
              <div key={index} style={styles.itemRow}>
                <span style={styles.itemText}>
                  Schedule {item.schedule} — {item.description}
                </span>
                <button style={styles.removeButton}
                  onClick={() => handleRemoveItem(index)}>Remove</button>
              </div>
            ))}
          </div>
        )}

        <button
          style={items.length === 0 ? styles.buttonDisabled : styles.button}
          onClick={handleContinue}
          disabled={items.length === 0}
        >
          Continue to Page 3
        </button>
        {items.length === 0 && (
          <p style={styles.hint}>Add at least one item to continue.</p>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f4f6f9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
  },
  card: {
    backgroundColor: '#ffffff',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '560px',
  },
  title: {
    color: '#1a3a5c',
    fontSize: '22px',
    marginBottom: '4px',
    textAlign: 'center',
  },
  meta: {
    textAlign: 'center',
    fontSize: '13px',
    color: '#666',
    marginBottom: '8px',
  },
  subtitle: {
    color: '#444',
    fontSize: '18px',
    marginBottom: '4px',
    textAlign: 'center',
  },
  required: {
    fontSize: '12px',
    color: '#666',
    marginBottom: '20px',
    textAlign: 'right',
  },
  field: {
    marginBottom: '16px',
  },
  row: {
    display: 'flex',
    gap: '12px',
    marginBottom: '16px',
  },
  halfField: {
    flex: 1,
  },
  label: {
    display: 'block',
    marginBottom: '6px',
    color: '#333',
    fontSize: '14px',
    fontWeight: '600',
  },
  input: {
    width: '100%',
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '14px',
    boxSizing: 'border-box',
  },
  addButton: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#2e7d32',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
    marginTop: '8px',
    marginBottom: '24px',
  },
  itemList: {
    marginBottom: '24px',
    borderTop: '1px solid #eee',
    paddingTop: '16px',
  },
  itemListTitle: {
    fontSize: '15px',
    color: '#333',
    marginBottom: '12px',
  },
  itemRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 0',
    borderBottom: '1px solid #f0f0f0',
  },
  itemText: {
    fontSize: '14px',
    color: '#333',
  },
  removeButton: {
    backgroundColor: 'transparent',
    border: '1px solid #cc0000',
    color: '#cc0000',
    padding: '4px 10px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '12px',
  },
  button: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#1a3a5c',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
  },
  buttonDisabled: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#aaa',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'not-allowed',
  },
  hint: {
    textAlign: 'center',
    fontSize: '12px',
    color: '#888',
    marginTop: '8px',
  },
};

export default Page2;